import { useCallback, useState } from 'react';
import { useMountedRef } from './use-mounted-ref';
import { delay } from '../../../common';

export const useModal = (initialIsOpen) => {
  const [isOpen, setIsOpen] = useState(initialIsOpen);
  const refMounted = useMountedRef();

  const closeModal = useCallback(async (onClose) => {
    if (!refMounted.current) {
      return;
    }

    setIsOpen(false);
    await delay(300);
    if (typeof onClose === 'function') {
      onClose();
    }
  }, [refMounted]);

  const openModal = useCallback((onOpen) => {
    if (!refMounted.current) {
      return;
    }

    setIsOpen(true);
    if (typeof onOpen === 'function') {
      onOpen();
    }
  }, [refMounted]);

  return [isOpen, openModal, closeModal];
}